// extracted by mini-css-extract-plugin
module.exports = {"container":"wzP___","content":"YHxStj","description":"_32UfPc"};